import { useMemo } from 'react';
import { STRIPE_APPEARANCE } from '@/pages/customer/pawall/stripe/stripeAppearance';
import { getStripeCurrencyByLang } from '@/pages/customer/pawall/stripe/stripeCountryByLang';

const parsePlanAmount = (priceLabel) =>
	Math.round(parseFloat(priceLabel.replace(/[^\d.]/g, '')) * 100) || 1000;

export const useStripeCheckout = ({ selectedPlan, lang }) => {
	const currency = getStripeCurrencyByLang(lang);

	const options = useMemo(() => {
		if (!selectedPlan) {
			return null;
		}

		return {
			mode: 'subscription',
			amount: parsePlanAmount(selectedPlan.price),
			currency,
			appearance: STRIPE_APPEARANCE,
			loader: 'always',
		};
	}, [selectedPlan, currency]);

	return { options };
};
